import AppPlatformService from '../../../../../../services/AppPlatform/AppPlatformService';
import strings from './strings';

const localStrings = strings[AppPlatformService.getLanguage()];

const AppModalService = {
  strings: localStrings
};

export default AppModalService;
